import React, { memo } from 'react';
import { Legend, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, Text } from 'recharts';
import { StringToColor } from 'shared/utils/graphicUtil';
import { percentStrNoCommas } from 'shared/utils/strUtil';

const prepareTopPanelPieData = (data) => {
  let keys = [];
  data.forEach((item) => {
    keys.push(...Object.keys(item));
  });
  keys = [...new Set(keys)];
  const aggDataObj = {};
  for (const item of data) {
    for (const key of keys) {
      if (key in item) {
        aggDataObj[key] = key in aggDataObj ? aggDataObj[key] + item[key] : item[key];
      }
    }
  }
  const prepData = Object.keys(aggDataObj).map((key) => ({ value: aggDataObj[key], name: key }));
  return prepData;
};

const FillPieChart = memo((props) => (
  <ResponsiveContainer className="dashboard__chart-pie" width="100%" height={props.height}>
    <PieChart className="dashboard__chart-pie-container">
      <Pie
        data={prepareTopPanelPieData(props.data)}
        dataKey="value"
        nameKey="name"
        cy={140}
        // innerRadius="60%"
        outerRadius="85%"
      >
        {prepareTopPanelPieData(props.data).map((entry) => (
          <Cell
            key={entry.name}
            fill={props.colorFunc ? props.colorFunc(entry.name) : StringToColor.next(entry.name)}
          />
        ))}
      </Pie>
      <Tooltip formatter={(value) => `${percentStrNoCommas(value)}`} />
      <Text x={400} y={200} textAnchor="middle" dominantBaseline="middle">
        Donut
      </Text>
      {props.showLegend && <Legend />}
    </PieChart>
  </ResponsiveContainer>
));

export default FillPieChart;
